import React from 'react';
import { useLocation } from '@gatsbyjs/reach-router';
import { useStaticQuery, graphql } from 'gatsby';
import Twitter from './twitter';
import Facebook from './facebook';

type SeoProps = {
	title?: string;
	description?: string;
	image?: string;
	profile?: string;
};
const Seo: React.FC<SeoProps> = ({ title, description, image, profile }) => {
	const { pathname } = useLocation();
	const { site } = useStaticQuery(query);
	const {
		defaultTitle,
		titleTemplate,
		defaultDescription,
		siteUrl,
		defaultImage,
		twitterUsername,
		facebookAppID,
	} = site.siteMetadata;
	const seo = {
		title: title || defaultTitle,
		description: description || defaultDescription,
		image: image ? `${siteUrl}${image}` : `${siteUrl}${defaultImage}`,
		url: `${siteUrl}${pathname}`,
	};
	return (
		<>
			<html lang="en" />
			<title>{
				titleTemplate 
				? titleTemplate.replace(/%s/g, seo.title)
				: seo.title
			}</title>
			<meta name="description" content={seo.description} />
			<meta name="image" content={seo.image} />
			<meta name="viewport" content="width=device-width, initial-scale=1.0" />
			<Facebook
				pageUrl={seo.url}
				type={profile && 'profile'}
				title={seo.title}
				description={seo.description}
				image={seo.image}
				appID={facebookAppID}
			/>
			<Twitter
				username={twitterUsername}
				title={seo.title}
				description={seo.description}
				image={seo.image}
			/>
		</>
	);
};
export default Seo;
const query = graphql`
	query seoq {
		site {
			siteMetadata {
				defaultTitle: title
				titleTemplate
				defaultDescription: description
				siteUrl
				defaultImage: image
				twitterUsername
			}
		}
	}
`;
